import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% alennus valituista tuotteista',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% alennus tilauksen kokonaisarvosta',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Ilmainen tuote toisen tuotteen kanssa',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Ilmainen tuote tilauksen arvolla',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Osta yksi, saat toisen puoleen hintaan',
  [OFFER_KIND.BOGO]: 'Osta yksi, saat toisen ilmaiseksi',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} alennus valituista tuotteista',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} alennus tilauksen arvolla',
};
